import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-center gap-4 sm:flex-nowrap" }
const _hoisted_2 = { class: "text-[10px] uppercase" }

import { columns } from '@/tables/columns/log';
    import { DatePicker } from '@/components/ui/form';
    import { Head } from '@inertiajs/vue3';
    import { onUnmounted, ref } from 'vue';
    import { useLogStore } from '@/stores/log';
    import { useQuery, useQueryClient } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableExpandFilters from '@/components/datatable/DataTableExpandFilters.vue';
    import DataTableSearchButton from '@/components/datatable/DataTableSearchButton.vue';
    import LogFilters from '@/components/log/LogFilters.vue';
    import PageCard from '@/components/PageCard.vue';
    import QueryKey from '@/enums/QueryKey';
    import SystemCardMenu from '@/components/system/SystemCardMenu.vue';
    import type { PaginationState } from '@tanstack/vue-table';
    import type { BreadcrumbItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Log',
  setup(__props) {

    const logStore = useLogStore();
    const totalRecords = ref(0);

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.settings',
        },
        {
            title: 'menu.system',
            href: route('v2.vat-deadlines.index'),
        },
    ];

    const queryClient = useQueryClient();

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.LOGS],
        queryFn: getLogs,
    });

    async function getLogs() {
        const { data } = await axios.get(route('v2.log.table'), {
            params: {
                fromDate: logStore.startDate,
                toDate: logStore.endDate,
                selectedRows: logStore.selectedRows,
                length: logStore.pagination.pageSize,
                start: logStore.pagination.pageIndex * logStore.pagination.pageSize,
            },
        });
        totalRecords.value = data.recordsTotal;
        const rows = data?.data ?? [];
        return rows
            .slice()
            .sort(
                (a: any, b: any) =>
                    new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
            );
    }

    const handlePaginationChange = (newPagination: PaginationState) => {
        logStore.updatePagination(newPagination);
        refetch();
    };

    const handleRefetch = () => {
        refetch();
        queryClient.invalidateQueries({ queryKey: [QueryKey.ACTIVITIES] });
    };

    onUnmounted(() => {
        logStore.$reset();
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('activities.page_header')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        _createVNode(PageCard, { class: "min-h-auto" }, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).LOGS,
              columns: _unref(columns),
              data: _unref(data),
              loading: _unref(isPending),
              "enable-search": false,
              "enable-filters": false,
              "manual-sorting": true,
              "default-column-visibility": {
                    id: false,
                },
              "manual-pagination": true,
              "total-records": totalRecords.value,
              "default-pagination": _unref(logStore).pagination,
              onPaginationChange: handlePaginationChange,
              "toolbar-class": "sm:flex-wrap lg:flex-nowrap lg:items-center"
            }, {
              title: _withCtx(() => [
                _createVNode(SystemCardMenu)
              ]),
              actions: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('activities.date_selection')), 1),
                  _createVNode(_unref(DatePicker), {
                    modelValue: _unref(logStore).startDate,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(logStore).startDate) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_unref(DatePicker), {
                    modelValue: _unref(logStore).endDate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(logStore).endDate) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(DataTableSearchButton, {
                    onRefetch: handleRefetch,
                    "is-fetching": _unref(isFetching)
                  }, null, 8, ["is-fetching"]),
                  _createVNode(DataTableExpandFilters)
                ])
              ]),
              "table-top": _withCtx(() => [
                _createVNode(LogFilters)
              ]),
              _: 1
            }, 8, ["table-key", "columns", "data", "loading", "total-records", "default-pagination"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})